import { Link as RouterLink } from 'react-router';
// material
import { Box, Stack, Tooltip, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
// icons
import LockIcon from '@mui/icons-material/Lock';
// routes
import { COMPLIANCE_PATHS } from 'src/routes/paths';
// components
import HouseholdLanguage from '../../../Household/HouseholdLanguage';
import { buildHouseholdUrl } from 'src/utils/buildHouseholdUrl';

export const SelectedMemberDetails = ({
  selectedMember,
  currentCertification,
}) => {
  const theme = useTheme();

  const getPropertyViewPath = (propertySlug) => {
    return COMPLIANCE_PATHS.general.property.replace(
      ':property_slug',
      propertySlug
    );
  };

  const getCertificationViewPath = (id, propertySlug) => {
    return COMPLIANCE_PATHS.certification.view
      .replace(':property_slug', propertySlug)
      .replace(':certification_id', id)
      .replace(':tab', 'summary');
  };

  const getHouseholdViewPath = (certId, propertySlug) => {
    return buildHouseholdUrl(propertySlug, { certificationId: certId });
  };

  const getUnitViewPath = (id, propertySlug) => {
    return COMPLIANCE_PATHS.unit.view
      .replace(':property_slug', propertySlug)
      .replace(':unit_id', id);
  };

  return (
    <>
      <Box sx={{ mt: 2 }}>
        <Stack
          direction="row"
          sx={{
            gap: 0.5,
            whiteSpace: 'nowrap',
            alignItems: 'center',
          }}
        >
          <Typography
            variant="h6"
            sx={{
              color: 'text.secondary',
              lineHeight: '18px',
              textTransform: 'capitalize',
            }}
          >
            {`${selectedMember.first_name} ${selectedMember.last_name}` ||
              selectedMember.email}
          </Typography>
          <HouseholdLanguage
            preferredLanguage={selectedMember?.preferred_language?.name}
          />
        </Stack>
        <Typography
          variant="caption"
          style={{ textTransform: 'capitalize' }}
          sx={{
            color: 'text.disabled',
          }}
        >
          {`${
            selectedMember.member_type.display_name ||
            selectedMember.member_type.name
          }`}
        </Typography>
        {currentCertification && (
          <Box
            sx={{
              mt: 1,
            }}
          >
            <Typography
              variant="body2"
              style={{ textTransform: 'capitalize' }}
              sx={{
                color: 'text.disabled',
              }}
            >
              <b>Household: </b>
              <RouterLink
                to={getHouseholdViewPath(
                  currentCertification?.id,
                  currentCertification?.property.slug
                )}
              >
                {`${selectedMember.household?.name || '-'}`}
              </RouterLink>
            </Typography>
            <Stack direction="row" spacing={0.5}>
              <Typography
                variant="body2"
                sx={{
                  color: 'text.disabled',
                }}
              >
                <b>Certification: </b>
                <RouterLink
                  to={getCertificationViewPath(
                    currentCertification.id,
                    currentCertification?.property.slug
                  )}
                >
                  {currentCertification.display_name}
                </RouterLink>
              </Typography>
              {!currentCertification?.is_active &&
                currentCertification.is_done && (
                  <Tooltip
                    title="This certification is done."
                    placement="top"
                    arrow
                  >
                    <LockIcon
                      sx={{ color: theme.palette.grey[400], fontSize: 20 }}
                    />
                  </Tooltip>
                )}
            </Stack>
            {currentCertification?.log_number && (
              <Typography
                variant="caption"
                style={{ textTransform: 'capitalize' }}
                sx={{
                  color: 'text.disabled',
                }}
              >
                {`Log Number: ${
                  String(currentCertification?.log_number) || '-'
                }`}
              </Typography>
            )}
            <Typography
              variant="body2"
              style={{ textTransform: 'capitalize' }}
              sx={{
                color: 'text.disabled',
              }}
            >
              <b>Property: </b>
              <RouterLink
                to={getPropertyViewPath(currentCertification?.property.slug)}
              >
                {`${currentCertification?.property?.name || '-'}`}
              </RouterLink>
            </Typography>
          </Box>
        )}
        {selectedMember.household?.unit?.id && (
          <Typography
            variant="body2"
            style={{ textTransform: 'capitalize' }}
            sx={{
              color: 'text.disabled',
            }}
          >
            <b>Unit: </b>
            <RouterLink
              to={getUnitViewPath(
                selectedMember.household?.unit?.id,
                selectedMember?.household?.unit?.building?.property?.slug
              )}
            >
              {`${selectedMember.household?.unit?.name || '-'}`}
            </RouterLink>
          </Typography>
        )}
        {selectedMember.household?.unit?.id && (
          <Typography
            variant="caption"
            style={{ textTransform: 'capitalize' }}
            sx={{
              my: 0,
              color: 'text.disabled',
              marginBottom: '16px',
            }}
          >
            {`Building Name: ${
              selectedMember.household?.unit?.building?.name || '-'
            }`}
          </Typography>
        )}
        {selectedMember.household?.unit?.id && (
          <Typography
            variant="caption"
            style={{ textTransform: 'capitalize' }}
            sx={{
              my: 0,
              color: 'text.disabled',
              marginBottom: '16px',
            }}
          >
            {`Applicant Pool: ${
              selectedMember.household?.unit?.building?.applicant_pool?.name ||
              '-'
            }`}
          </Typography>
        )}
      </Box>
    </>
  );
};
